import { Box, Header, Text, VStack } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const AdditionalInformation = Box.withConfig({
  marginTop: '$2',
  marginBottom: '$7',
  alignItems: 'center',
  _text: {
    color: Styles.color.primary,
    fontSize: 'md',
  },
});

export const DeliveryLogoContainer = Box.withConfig({
  width: '$40',
  marginTop: '$12',
  marginX: 'auto',
  marginBottom: '0',
});

export const LoadingText = Text.withConfig({
  margin: '0',
  fontWeight: 'black',
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
});

export const ButtonContainer = Box.withConfig({
  marginY: '$4',
  paddingX: '$4',
  width: {
    base: 'full',
    md: '50%',
  },
  _web: {
    alignSelf: 'center',
  },
  maxWidth: 'xl',
});

export const NewAddressModalHeading = Box.withConfig({
  marginTop: '$1',
  marginBottom: '$1',
  marginX: '0',
  width: 'full',
  maxWidth: 'full',
});

export const DeliveryInfoContainer = Box.withConfig({
  marginBottom: '$4',
  marginY: '$12',
  alignSelf: 'center',
});

export const ModalTitle = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const AddressInfoLine = Header.withConfig({
  variant: 'headerThree',
  margin: '0',
  marginTop: '$5',
  marginBottom: '1',
});

export const AliasOptions = Header.withConfig({
  variant: 'headerFour',
  margin: '0',
});
export const AliasOptionBox = Box.withConfig({
  px: '$4',
  py: '$3',
  borderRadius: '$full',
  borderWidth: 1,
  borderColor: '$brown600',
  backgroundColor: 'transparent',
  alignItems: 'center',
  justifyContent: 'center',
});

export const AliasOptionText = Text.withConfig({
  fontSize: 'sm',
  fontWeight: '600',
  color: '$brown600',
});

export const AliasOptionBoxSelected = AliasOptionBox.withConfig({
  backgroundColor: '$brown600',
});

export const AliasOptionTextSelected = AliasOptionText.withConfig({
  color: '$white',
});

export const AddressFormContainer = Box.withConfig({
  width: {
    base: 'full',
  },
  paddingY: '$4',
  paddingX: '$4',
  borderStyle: 'solid',
  borderRadius: '10',
  borderBottomWidth: '1px',
  borderColor: Styles.color.white,
  flex: 1,
  _web: {
    alignSelf: 'center',
  },
});

export const DeliveryAddressesFormContainer = VStack.withConfig({
  flex: 1,
  paddingY: '$0',
  paddingX: '$4',
});

export const deliveryAddressFormHeaderStyles = StyleSheet.create({
  modalHeading: {
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  side: {
    width: '20%',
    alignItems: 'flex-start',
  },
  center: {
    width: '60%',
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: primitive.bk.$bbqBrown,
    textAlign: 'center',
  },
});

export const DialogStyles = StyleSheet.create({
  headingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  bodyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
});

export const lockInputStyle = StyleSheet.create({
  lockedContainer: {
    paddingVertical: 15,
    minHeight: 30,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 4,
    backgroundColor: '#F3F4F6',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
  },
  lockedText: {
    flex: 1,
    fontFamily: 'Flame-RegularSans',
    color: '#6B7280',
  },
  iconContainer: {
    marginLeft: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
